<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered">
        <b-icon type="is-info" icon="alert-circle" class="icon-modal"></b-icon>
        <p class="title is-size-4 has-text-centered">
          {{ $t('general.permission.unAuthorized') }}
        </p>
        <br>
        <p class="modal-subtitle">
          {{ $t('general.permission.contactAdmin') }}
        </p>
      </section>
      <br>
      <main>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="closePopup()">
            {{ $t('general.permission.close') }}
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'popUpPermission',
  methods: {
    ...permissions.mapActions({
      closePopupPermission: 'hidePopup',
    }),
    closePopup() {
      this.closePopupPermission();
    },
  },
};
</script>

<style scoped>

</style>
